module.exports = __webpack_public_path__ + "img/ereszkalkulator_kicsi_haz_osszetett_kontyolt_nyeregteto_szurke.79672f7d.png";